import { useDependencies } from '../hooks/useDependencies';
import { ActionOption, ButtonWithActionMenu } from './atoms/ButtonWithActionMenu';
import { useSelector } from 'react-redux';
import { SalesforceItem } from '../../../parser/ConfigurationItemTypes';
import { useFeatureToggle } from '../../../../feature-flags/useFeatureToggle';
import { selectSaltoObjectTypes } from '../../../../reducers/global/parserReducer';
import { DocumentationCardHeaderLayout } from '../../building-blocks/documentation-card/DocumentationCardHeaderLayout';
import { SfConfigTitle } from './atoms/SfConfigTitle';

interface SourceCodeHeaderProps {
  configurationItem: SalesforceItem;
  type: string;
  crmOrgId: string;
  readOnly?: boolean;
}

export const SourceCodeHeader = ({ configurationItem, type, crmOrgId }: SourceCodeHeaderProps) => {
  const { searchInDocumentationCard } = useFeatureToggle();
  const { onGoToDependenciesMainView, onGoBackInHistory, historyLength } =
    useDependencies(crmOrgId);
  const onGoBackFunc = historyLength > 1 ? onGoBackInHistory : onGoToDependenciesMainView;

  const { updatedBy, updatedAt } = configurationItem ?? {};
  const saltoObjectTypes = useSelector(selectSaltoObjectTypes(crmOrgId));

  return (
    <DocumentationCardHeaderLayout
      title={
        <SfConfigTitle
          configurationItem={configurationItem}
          type={type}
          saltoObjectTypes={saltoObjectTypes ?? []}
        />
      }
      onGoBack={onGoBackFunc}
      shouldDisplayBackButton
      searchEnabled={searchInDocumentationCard}
      actions={
        <ButtonWithActionMenu
          options={[ActionOption.openInSalesforce, ActionOption.comments]}
          configurationItem={configurationItem}
          crmOrgId={crmOrgId}
          lastUpdatedInfo={updatedBy && updatedAt ? { updatedBy, updatedAt } : undefined}
        />
      }
    />
  );
};
